module.exports = __webpack_public_path__ + "static/media/lobby.a87fbc8c.jpg";